import React, { useState } from "react";
import {
  Col,
  Form,
  Row,
  Tab,
  Tabs,
  Modal,
  Table,
} from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import {
  numberFormat,
  refreshPage,
  toastStyle,
  getTodayDate,
  getType,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { validatePayrollModal } from "./../../../Helpers/Validation/Employees/PayrollValidation";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { getAllBranches } from "./../../../Helpers/apiCalls/Manage/Branches";
import {
  getAllSchedule,
  deleteScheduleMultiple,
} from "./../../../Helpers/apiCalls/Employees/SchedulerApi";
import Footer from "../../../Components/Footer/Footer";

export default function EmployeeScheduler() {
  let navigate = useNavigate();
  const accountType = getType();
  const [inactive, setInactive] = useState(true);
  const today = new Date();
  const twoweeksago = new Date();
  twoweeksago.setDate(twoweeksago.getDate() - 14);
  const [filterConfig, setFilterConfig] = useState({
    employee_id: "",
    employee_name: "",
    date_from: twoweeksago,
    date_to: today,
    user: accountType,
  });

  const [branches, setBranches] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [allData, setAllData] = useState([]);
  const [totalHours, setTotalHours] = useState("0");
  const [isClicked, setIsClicked] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  /* add modal handler */
  const [showAddModal, setShowAddModal] = useState(false);
  const handleShowAddModal = () => setShowAddModal(true);
  const handleCloseAddModal = () => setShowAddModal(false);

  const [selectedRow, setSelectedRow] = useState([]);

  const xlsxHeaders = [
    "Date",
    "Crew",
    "Shift Start",
    "Break Start",
    "Break End",
    "Hrs Break",
    "Shift End",
    "Hrs Worked",
  ];

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Date</th>
            <th>Crew</th>
            <th>Start</th>
            <th>End</th>
            <th>Hrs Worked</th>
            <th>Break Start</th>
            <th>Break End</th>
            <th>Hrs Break</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{selectedRow.date}</td>
            <td>{selectedRow.employee_name}</td>
            <td>{selectedRow.time_start}</td>
            <td>{selectedRow.time_end}</td>
            <td>{selectedRow.hours_total}</td>
            <td>{selectedRow.break_time}</td>
            <td>{selectedRow.break_end}</td>
            <td>{selectedRow.break_hours}</td>
          </tr>
          {/* {items.map((item) => {
                        
                    })} */}
        </tbody>
      </Table>
    );
  }

  function renderTableEdited() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Date</th>
            <th>Crew</th>
            <th>Start</th>
            <th>End</th>
            <th>Hrs Worked</th>
            <th>Break Start</th>
            <th>Break End</th>
            <th>Hrs Break</th>
          </tr>
        </thead>
        <tbody>
          {selectedRow.original_sched?.map((data, index) => {
            return (
              <tr>
                <td>{data.date}</td>
                <td>{data.employee_name}</td>
                <td>{data.time_start}</td>
                <td>{data.time_end}</td>
                <td>{data.hours_total}</td>
                <td>{data.break_time}</td>
                <td>{data.break_end}</td>
                <td>{data.break_hours}</td>
              </tr>
            );
          })}
          {/* {items.map((item) => {
                        
                    })} */}
        </tbody>
      </Table>
    );
  }

  const handleTabSelect = (tabKey) => {
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        branch_id: "",
        employee_id: "",
        date_from: "",
        date_to: "",
      };
    });
  };

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row);

    if (e.target.value === "view") {
      ViewSched(row);
    } else if (e.target.value === "edit") {
      navigate("/scheduler/edit/single/" + row.id + "/" + row.shop);
      // navigate("/payroll/edit/single" + row.id, {
      //     state: { date_from: row.date_from, date_to: row.date_to  },
      // })
    } else if (e.target.value === "delete") {
      handleShowDeleteModal();
    }
  }

  function isDateBefore(inputDate) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const [inputMonth, inputDay, inputYear] = inputDate.split("-");
    const parsedDate = new Date(`${inputYear}-${inputMonth}-${inputDay}`);

    return parsedDate < currentDate;
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        <option value="view" className="color-options">
          View
        </option>
        {!isDateBefore(row.date) && (
          <option value="edit" className="color-options">
            Edit
          </option>
        )}
        {!isDateBefore(row.date) && (
          <option value="delete" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    );
  }

  function ViewSched(row) {
    setSelectedRow(row);
    handleShowAddModal();
  }

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={() => ViewSched(row)}
      >
        View
      </button>
    );
  }

  async function fetchEmployees() {
    const response = await getAllEmployees();
    if (response.error) {
      setEmployees([]);
    } else {
      let result = response.data.data.map((data) => {
        var employee = data;
        employee.label = data.first_name + " " + data.last_name;
        employee.value = data.id;
        return employee;
      });
      setEmployees([{ label: "All Employees", value: "" }, ...result]);
    }
  }

  async function fetchBranches() {
    setShowLoader(true);
    setBranches([]);
    const response = await getAllBranches();
    if (response.error) {
      setBranches([]);
    } else {
      var allBranches = response.data.data.data
        .filter((data) => {
          return data.is_franchise === "0";
        })
        .map((data) => {
          var branch = data;
          branch.label = data.name;
          branch.value = data.id;
          return branch;
        });
      setBranches([{ label: "All Branches", value: "" }, ...allBranches]);
    }
    setShowLoader(false);
  }

  async function fetchData() {
    setShowLoader(true);
    setAllData([]);
    setExcelData([]);
    setTotalHours("0");

    const response = await getAllSchedule(filterConfig);

    if (response.error) {
      setAllData([]);
    } else {
      var data = response.data.data.map((bill) => {
        if (bill.is_dayoff === "0") {
          var info = bill;
          var formattedTimeStart = bill.time_start
            ? Moment(bill.time_start, "HH:mm:ss").format("h:mm A")
            : "";
          var formattedTimeEnd = bill.time_end
            ? Moment(bill.time_end, "HH:mm:ss").format("h:mm A")
            : "";
          var formattedBreakStart = bill.break_time
            ? Moment(bill.break_time, "HH:mm:ss").format("h:mm A")
            : "";
          var formattedBreakEnd = bill.break_end
            ? Moment(bill.break_end, "HH:mm:ss").format("h:mm A")
            : "";

          info.date = Moment(bill.date).format("MM-DD-YYYY");
          info.time_start = formattedTimeStart;
          info.time_end = formattedTimeEnd;
          info.break_time = formattedBreakStart;
          info.break_end = formattedBreakEnd;
          info.cash_advance = bill.amount ? numberFormat(bill.amount) : "0.00";
          info.shop = "paperworld";
          return info;
        } else {
          var info = bill;

          info.date = Moment(bill.date).format("MM-DD-YYYY");
          info.time_start = "--";
          info.time_end = "--";
          info.break_time = "--";
          info.break_end = "DAY OFF";
          info.break_hours = "--";
          info.hours_total = "--";
          info.shop = "paperworld";

          return info;
        }
      });
      setAllData(data);

      var excel = data.map((bill) => {
        if (bill.is_dayoff === "0") {
          var info = {};
          info.date = bill.date;
          info.employee_name = bill.employee_name;
          info.time_start = bill.time_start;
          info.break_time = bill.break_time;
          info.break_end = bill.break_end;
          info.break_hours = bill.break_hours;
          info.time_end = bill.time_end;
          info.hours_total = bill.hours_total;
          return info;
        } else {
          var info = {};
          info.date = bill.date;
          info.employee_name = bill.employee_name;
          info.time_start = "--";
          info.break_time = "--";
          info.break_end = "DAY OFF";
          info.break_hours = "--";
          info.time_end = "--";
          info.hours_total = "--";
          return info;
        }
      });
      setExcelData(excel);

      var hours = response.data.summary
        ? response.data.summary.total_required_hours
        : "0.00";
      setTotalHours(hours);
    }

    setShowLoader(false);
  }

  async function handleDeleteSchedule() {
    setIsClicked(true);

    if (checkedItems.length > 0) {
      const response = await deleteScheduleMultiple(checkedItems);
      if (response.data) {
        toast.success("Payroll Deleted Successfully!", {
          style: toastStyle(),
        });
        setTimeout(() => refreshPage(), 1000);
      } else {
        setIsClicked(false);
        toast.error("Error Deleting Payroll", {
          style: toastStyle(),
        });
        setTimeout(() => refreshPage(), 1000);
      }
    } else {
      const response = await deleteScheduleMultiple([selectedRow]);
      if (response.data) {
        toast.success("Payroll Deleted Successfully!", {
          style: toastStyle(),
        });
        setTimeout(() => refreshPage(), 1000);
      } else {
        setIsClicked(false);
        toast.error("Error Deleting Payroll", {
          style: toastStyle(),
        });
        setTimeout(() => refreshPage(), 1000);
      }
    }
  }

  function handleOnCheck(row) {
    setCheckedItems(row.selectedRows);
  }

  function handleExport() {
    const rows = excelData;

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
    XLSX.writeFile(
      workbook,
      `EmployeeScheduler (${Moment(filterConfig.date_from).format(
        "MMM DD, YYYY"
      )} - ${Moment(filterConfig.date_to).format("MMM DD, YYYY")}).xlsx`,
      { compression: true }
    );
  }

  React.useEffect(() => {
    fetchBranches();
    fetchEmployees();
  }, [filterConfig.tab]);

  React.useEffect(() => {
    fetchData();
  }, [filterConfig]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"PAYROLL"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={5}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> EMPLOYEE SCHEDULER </h1>
          </Col>
          <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  name="employee_name"
              placeholder="Search employee name"
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
              }
              />
          </Col>
          <Col lg={2} className="mt-2 mt-lg-0">
              <div className="PO-filters">
              <button
              className="add-btn"
              onClick={() => navigate("/scheduler/add/multiple")}
            >
              Generate
            </button>
              </div>
          </Col>
          <Col lg={2} className="mt-2 mt-lg-0">
              <div className="PO-filters">
              <button
              className="add-btn"
              onClick={() => navigate("/scheduler/add/single")}
            >
              Add
            </button>
              </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="mb-3">
            <span className="PI-modal-label grey text-normal">
              TOTAL SCHEDULED HOURS: {numberFormat(totalHours)}
            </span>
          </Col>
        </Row>

        <Tabs
          activeKey={filterConfig.tab}
          id="PO-tabs"
          className="manager-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="paperworld" title="All">
            <div className="tab-content">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Branch"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: state.isSelected ? "white" : "var(--primary-color)",
                      borderRadius: "7px",
                      border: "0px",
                      minHeight: "20px",
                      maxHeight: "35px",
                    }),
                    input: (baseStyles, state) => ({
                      ...baseStyles,
                      color: state.isSelected ? "white" : "white",
                    }),
                    dropdownIndicator: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "white",
                    }),
                    singleValue: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "white",
                    }),
                    placeholder: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "white",
                    }),
                  }}
                  options={branches}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return { ...prev, branch_id: e.value };
                    });
                  }}
                />
                </Col>
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Employee"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      backgroundColor: state.isSelected ? "white" : "var(--primary-color)",
                      borderRadius: "7px",
                      border: "0px",
                      minHeight: "20px",
                      maxHeight: "35px",
                    }),
                    input: (baseStyles, state) => ({
                      ...baseStyles,
                      color: state.isSelected ? "white" : "white",
                    }),
                    dropdownIndicator: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "white",
                    }),
                    singleValue: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "white",
                    }),
                    placeholder: (baseStyles, state) => ({
                      ...baseStyles,
                      color: "white",
                    }),
                  }}
                  options={employees}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return { ...prev, employee_id: e.value };
                    });
                  }}
                />
                </Col>
                <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_from}
                  name="date_from"
                  placeholderText={"Select Date From"}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
                </Col>
                <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_to}
                  name="date_to"
                  placeholderText={"Select Date To"}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                  minDate={filterConfig.date_from ? filterConfig.date_from : ""}
                />
              </Col>
            </Row>
            <div className="mb-2" />
              <div className="below">
                <AdjustmentTable
                  tableHeaders={[
                    "-",
                    "DATE",
                    "BRANCH",
                    "CREW",
                    "SHIFT START",
                    "BREAK START",
                    "BREAK END",
                    "HRS BREAK",
                    "SHIFT END",
                    "HRS WORKED",
                    // "DAYOFF",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "-",
                    "date",
                    "branch_name",
                    "employee_name",
                    "time_start",
                    "break_time",
                    "break_end",
                    "break_hours",
                    "time_end",
                    "hours_total",
                    // "dayoff",
                  ]}
                  tableData={allData}
                  ActionBtn={(row) => ActionBtn(row)}
                  ViewBtn={(row) => ViewBtn(row)}
                  handleOnCheck={(row) => handleOnCheck(row)}
                  showLoader={showLoader}
                />
              </div>
              <div className="mb-2" />
            </div>
          </Tab>
        </Tabs>
        {checkedItems.length > 0 && (
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-warning me-3"
              onClick={handleShowDeleteModal}
            >
              Delete
            </button>
          </div>
        )}
        <div className="mb-3" />
        <Row>
            <Col lg={10} className="mt-3 mt-lg-0"></Col>
            <Col lg={2} className="mt-3 mt-lg-0">
              <div className="PO-filters">
                <button
                    type="button"
                    className="primary-btn"
                    onClick={handleExport}
                >
                    <span className="me-2">
                        <img
                            width={20}
                            height={20}
                            src={downloadIcon} alt=""
                        ></img>
                    </span>
                    Download
                </button>
              </div>
          </Col>
        </Row>
      </div>

      {/* modals */}
      <Delete
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        text="scheduler"
        onDelete={handleDeleteSchedule}
        isClicked={isClicked}
      />

      <Modal
        show={showAddModal}
        onHide={handleCloseAddModal}
        size="xl"
        centered
      >
        <Modal.Body>
          <span className="PI-modal-header">{selectedRow.branch_name}</span>
          <div className="PI-modal-body mt-3">
            <Row className="mt-3 mb-2">
              <span className="PI-modal-label">Schedule</span>
              <div className="print-table w-95 mt-3 mx-3">{renderTable()}</div>
            </Row>
            {selectedRow.original_sched?.length > 0 && (
              <Row className="mt-3">
                <span className="PI-modal-label">Old Schedule</span>
                <div className="print-table w-95 mt-3 mx-3">
                  {renderTableEdited()}
                </div>
              </Row>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="PI-modal-buttons">
          <button
            type="button"
            onClick={handleCloseAddModal}
            className="button-secondary"
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <Footer/>
    </div>
  );
}
